import { styled, SearchField as ComponentsSearchField } from "@tm/components"

export const SearchField = styled(ComponentsSearchField)(({ theme }) => ({
    width: 350,
}))
